import requestProvider from "./axiosHandler";

const getAllScrap = () => {
    return requestProvider
        .get('/scrap/get-all')
};

const createAllScrap = (list) => {
    return requestProvider
        .post('/scrap/create-all', list)
};

const createScrap = (list) => {
    return requestProvider
        .post('/scrap', list)
};

const updateScrap = (list) => {
    return requestProvider
        .put('/scrap', list)
};

const deleteScrap = (id) => {
    return requestProvider
        .delete(`/scrap/${id}`)
};

const getScrapById = (id) => {
    return requestProvider
        .get(`/scrap/${id}`)
};

const getScrapsWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/scrap?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllScrap, createScrap, createAllScrap, updateScrap, deleteScrap, getScrapById, getScrapsWithPage}